import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    Box,
    IconButton,
    DialogContent,
    Grid,
    Button,
    Stack,
    Alert,
    TextField,
    DialogActions,
    InputAdornment

} from '@mui/material';
// import required css from library
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { Close } from '@mui/icons-material';
import { CustomizedSnackbar } from '../../../shared/index';
import { axiosFetch } from "../../../utils/AxiosFetch";
import { Link, useNavigate } from 'react-router-dom'
import dummyData from './SearchKeyResultsDummyData.json';
import { StencilList } from "react-placemoulder";
import InfiniteScroll from "react-infinite-scroller";
import SearchKeyResultsList from "./SearchKeyResultList";
import SearchIcon from '@mui/icons-material/Search';
import { SnackbarActions } from '../../../redux/actions/snackbar.actions';
import { useDispatch } from "react-redux";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    // ValidatorForm.addValidationRule("")
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const SearchKeyResultsPopup = (props) => {

    // ValidatorForm.addValidationRule('isValid', (value) => {
    //     var titleRegx = "^[A-Za-z_ |-][A-Za-z0-9_@./#&+() |-]*$"

    //     if (value.match(titleRegx)) {
    //         return true;
    //     }
    //     return false;

    // })

    ValidatorForm.addValidationRule("minLength", (value) => {
        if (value.length > 2) {
            return true;
        }
        return false;
    })


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [open, setOpen] = useState(props && props.open);
    const [keyword, setKeyword] = useState("");
    const [isSelected, setIsSelected] = useState(false);
    const [keyResultList, setKeyResultList] = useState(dummyData);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [scrolling, setScrolling] = useState(false);
    const [totalRecords, setTotalRecords] = React.useState("");
    const [totalPages, setTotalPages] = React.useState("");
    const [resultsPerPage, setResultsPerPage] = React.useState(100);
    const [showContent, setShowContent] = useState(false);
    const [keyWordErrMsg, setKeywordErrMsg] = useState(false);

    const handleSubmit = () => {
        if (keyword === "") {
            setKeywordErrMsg(true);
            return false;
        }
        if (keyword !== "") {
            // setIsLoading(true);
            axiosFetch({
                method: "post",
                url: "/okrs/searchkr",
                requestConfig: {
                    "IsObjective": false,
                    "ObjectiveId": null,
                    keyword,
                    page,
                    resultsPerPage
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        setShowContent(true);
                        setIsLoading(false);
                        if (page > 1) {
                            var keyResults = [...keyResultList.krResult, ...res.data.krResult];
                            setKeyResultList({ krResult: keyResults });
                            setScrolling(false);
                        }
                        else {
                            setKeyResultList(res.data);
                        }
                        setTotalPages(res.data.totalPages);
                        setTotalRecords(res.data.totalRecords);
                    }
                    else if (res.status === 400) {

                        dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
                    }
                    else if (res.status === 401) {
                        navigate('/');
                    }

                })
                .catch(err => console.error(err));
        }
    }

    const handleSelect = (selectedItem) => {
        setIsSelected(!isSelected);
        props.handleChangeChosenKR({
            id: selectedItem.id,
            title: selectedItem.title
        });
        props.toggleKrPopup(false);

    }

    const handleInfiniteOnLoad = () => {
        alert("called")
        if (page + 1 <= totalPages) {
            setPage(page + 1);
        }
        setScrolling(true);
    }

    const handleClear = () => {
        setShowContent(false);
        setKeyword("");
    }

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value);
        setKeywordErrMsg(false);
    }


    return (
        <div id="scrollableDiv">
            {
                isLoading ? (
                    <StencilList
                        length={1}
                        Component={SearchKeyResultsList}
                        data={dummyData}
                    />
                ) : (<InfiniteScroll
                    dataLength={keyResultList.krResult.length}
                    initialLoad={false}
                    loadMore={() => handleInfiniteOnLoad()}
                    hasMore={true}
                    scrollThreshold={10}
                    scrollabletarget="scrollableDiv"
                    useWindow={false}
                >
                    <ValidatorForm onSubmit={handleSubmit}>
                        <BootstrapDialog
                            aria-labelledby="customized-dialog-title"
                            open={open}
                            fullWidth="sm"
                            maxWidth="sm"
                            onClose={() => props.toggleKrPopup(false)}
                        >


                            <BootstrapDialogTitle
                                id="customized-dialog-title"
                                onClose={() => props.toggleKrPopup(false)}
                                className="modal-heading"
                            >
                                Create objective from existing Key Result
                            </BootstrapDialogTitle>

                            <DialogContent dividers>
                                <Stack sx={{ width: '100%', marginBottom: "15px" }} >
                                    <Alert severity="warning">Objectives should provide business value and should be achievable. Think of the areas that need improvements in order to have better results.</Alert></Stack>
                                <Box
                                    alignItems="center"
                                    display="flex"
                                    justifyContent="center"
                                    component="form"
                                    autoComplete="off"
                                >
                                    <Grid container item spacing={2} xs={12} className="grid-margins">
                                        <Grid item xs={12} className="grid-margins">

                                            <TextValidator
                                                id="input-with-icon-textfield"
                                                variant="outlined"
                                                fullWidth
                                                label="Search Key Result"
                                                value={keyword}
                                                onChange={handleChangeKeyword}
                                                validators={["minLength"]}
                                                errorMessages={["Please fill out this field with minimum 3 characters"]}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton className="search-btn" style={{ cursor: "pointer" }} type="submit">
                                                                <SearchIcon />
                                                            </IconButton>
                                                            {/* <SearchIcon onClick={ } className="search-btn" style={{ cursor: "pointer" }} /> */}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                            {/* <span className="error-message">{keyWordErrMsg ? "Please fill out this field" : ""}</span> */}
                                        </Grid>
                                        <Grid item xs={12} style={{ paddingTop: "0px" }}>
                                            <Link to="" className="clear-all-link" variant="text" onClick={handleClear} style={{ float: "right" }}> Clear </Link>
                                        </Grid>
                                        {showContent ? <Grid item xs={12} className="grid-margins">
                                            <SearchKeyResultsList
                                                {...keyResultList}
                                                handleChangeChosenKR={handleSelect}
                                                toggleKrPopup={props.toggleKrPopup}
                                            />
                                        </Grid> : ""}
                                    </Grid>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button variant="text" className="theme-btn cancel-btn" onClick={() => props.toggleKrPopup(false)}>
                                    Cancel
                                </Button>
                            </DialogActions>

                            {/* </ValidatorForm> */}
                        </BootstrapDialog>
                    </ValidatorForm>
                    <CustomizedSnackbar />

                </InfiniteScroll >)
            }
        </div >
    );
};




export default SearchKeyResultsPopup;
